import { useEffect } from 'react';
import { useProposalStore } from '@/contexts/useProposalStore';
import { Box, Text } from '@chakra-ui/react';
import { initializeSDK } from '@/components/SdkSingleton';
// import { Proposal } from '@/models/proposal.model';
import { ProposalConsignado } from '@/models/proposalConsignado.model';

export default function ConsignadoSelfie(): JSX.Element | null {
    const { proposal  } = useProposalStore();
    // console.log('proposal', proposal);

    //    proposal_id: string;
    //     unico_id?: string | null;
    //     cpf?: string;
    //     nome: string;
    //     infromacoes_financeiras: any[];
    //     informacoes_seguro: any;
    //     UnicoData?: UnicoData | null;
    //     chosenFinancialInfo?: FinancialInfo | null;
    //     anticipatedYears?: number | null;
    //     Contract?: Contract | null;
    //     NaturalPerson?: NaturalPersonConsig | null;
    //     BankDetail?: BankDetail | null;
    
    useEffect(() => {
        if (!proposal) return;
        
        const unicoId = 'unico_id' in proposal 
            ? (proposal as ProposalConsignado)?.unico_id 
            : (proposal as ProposalConsignado)?.UnicoData?.unicoId;
        
        // console.log('useEffect called', {
        //     unicoId,
        // });

        if (unicoId) {
            initializeSDK({
                token: '',
                transactionId: unicoId,
                onFinish: (process: any) => {
                    console.log('Process', process);
                },
            });
        }
    }, [proposal]);

    if (!proposal) {
        return null;
    }

    const unicoId = 'unico_id' in proposal 
        ? (proposal as any)?.unico_id 
        : (proposal as any)?.UnicoData?.unicoId;
    
    if (!unicoId) {
        return null;
    }

    return (
        <Box padding="20px">
            <Text fontSize="2xl">Tirar Selfie</Text>
        </Box>
    );
}
